import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="transparent"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.0034 19.0031L5.49731 4.49707"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.4987 15.5015L3.99683 20.0033"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.46015 8.45947L4.97829 9.57994C4.62861 9.66735 4.35298 9.93611 4.25678 10.2835C4.16057 10.6308 4.25866 11.0031 4.51355 11.2579L12.7421 19.4865C12.997 19.7414 13.3692 19.8395 13.7166 19.7433C14.0639 19.6471 14.3327 19.3715 14.4201 19.0218L15.5405 14.5398"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.4638 12.4619L19.1124 11.3627C19.6112 11.0302 19.9346 10.4916 19.9937 9.89509C20.0527 9.29857 19.8412 8.707 19.4174 8.28313L15.7173 4.58311C15.2934 4.15925 14.7018 3.94775 14.1053 4.00682C13.5088 4.06588 12.9702 4.38929 12.6377 4.88805L11.5386 6.53668"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default SvgComponent
